import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import BaseInput from './BaseInput.vue';
import type { RegisterFormFieldProps } from '@/types/sellerRegister';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterFormField',
  props: {
    type: {},
    label: {},
    required: { type: Boolean },
    placeholder: {},
    modelValue: { type: [String, Number, Boolean, null, Array] },
    options: {},
    rows: {},
    min: {},
    max: {},
    step: {},
    disabled: { type: Boolean },
    error: {},
    gridClass: {},
    minLength: {},
    maxLength: {}
  },
  emits: ["update:modelValue", "validation-changed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Gestion de la validation
const handleValidationChanged = (isValid: boolean) => {
  emit('validation-changed', isValid)
}

const emit = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.gridClass)
  }, [
    _createVNode(BaseInput, _mergeProps(_ctx.$props, {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
      onValidationChanged: handleValidationChanged,
      maxLength: props.maxLength
    }), null, 16, ["maxLength"])
  ], 2))
}
}

})